__turbopack_context__.v({
  "container": "KB4KrW_container",
  "content": "KB4KrW_content",
  "drawerButton": "KB4KrW_drawerButton",
  "sidebar": "KB4KrW_sidebar",
  "sidebarToggle": "KB4KrW_sidebarToggle",
});
